<h1>
  <ng-content></ng-content>
</h1>
<ng-content select="gax-help-icon"></ng-content>
